/* eslint-disable consistent-return */
import React, { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';
import * as sc from '../../widget-bar.styles';

const formatNumberAsTime = (number: number) => {
  return String(number).padStart(2, '0');
};

const getTimerFormat = (expiresOn: string) => {
  const now = dayjs();
  const expires = dayjs(expiresOn);
  if (expires.isBefore(now)) return '00:00:00';
  const hours = formatNumberAsTime(expires.diff(now, 'hour'));
  const minutes = formatNumberAsTime(expires.diff(now, 'minute') % 60);
  const seconds = formatNumberAsTime(expires.diff(now, 'second') % 60);
  return `${hours}:${minutes}:${seconds}`;
};

const defaultProps = {
  display: true,
  isMobile: false,
  vehicleAvailable: true,
  vehicleLock: {
    expiresOn: dayjs().add(1, 'hour').toISOString()
  }
};

const LockTimerWidget = (props = defaultProps) => {
  const { display, isMobile, vehicleAvailable, vehicleLock: lock } = props;
  const requestRef = useRef<ReturnType<typeof requestAnimationFrame>>();
  const [timerDisplay, setTimerDisplay] = useState(
    getTimerFormat(lock.expiresOn)
  );

  const animate = () => {
    const newTimerDisplay = getTimerFormat(lock.expiresOn);
    if (newTimerDisplay !== timerDisplay) setTimerDisplay(newTimerDisplay);
    requestRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => {
      if (requestRef.current) cancelAnimationFrame(requestRef.current);
    };
  }, []);

  if (!display || !vehicleAvailable) return null;

  return (
    <sc.WidgetWrapper>
      <sc.ClockIcon />
      <sc.TextWrapper>
        {!isMobile && <sc.WidgetLabel>Vehicle Reserved</sc.WidgetLabel>}
        <sc.WidgetValue>{timerDisplay}</sc.WidgetValue>
      </sc.TextWrapper>
    </sc.WidgetWrapper>
  );
};

export default LockTimerWidget;
